import Setting from ".";
const NotFoundRoutes = {
  routes: [
    {
      path: "/error/404",
      component: Setting,
      exact: true,
    },
  ],
};
export default NotFoundRoutes;
